<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.queries' | translate}}"
  [hidePagination]="true"
  [itemsData]="displayedQueries"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'queries'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        packageName
      </th>
      <th>
        className
      </th>
      <th>
        methodName
      </th>
      <th>
        lineNumber
      </th>
      <th>
        endpointCalls
      </th>
      <th>
        minExecutionTime
      </th>
      <th>
        avgExecutionTime
      </th>
      <th>
        maxExecutionTime
      </th>
      <th>
        minResultCount
      </th>
      <th>
        avgResultCount
      </th>
      <th>
        maxResultCount
      </th>
      <th>
        firstStarted
      </th>
      <th>
        firstFinished
      </th>
      <th>
        lastStarted
      </th>
      <th>
        lastFinished
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-query>

    <tr>
      <td>
        {{ query?.resourceDescriptor?.packageName }}
      </td>
      <td>
        {{ query?.resourceDescriptor?.className }}
      </td>
      <td>
        {{ query?.resourceDescriptor?.methodName }}
      </td>
      <td>
        {{ query?.resourceDescriptor?.lineNumber }}
      </td>
      <td>
        {{ query.endpointCalls }}
      </td>
      <td>
        {{ query.minExecutionTime }}
      </td>
      <td>
        {{ query.avgExecutionTime }}
      </td>
      <td>
        {{ query.maxExecutionTime }}
      </td>
      <td>
        {{ query.minResultCount }}
      </td>
      <td>
        {{ query.avgResultCount }}
      </td>
      <td>
        {{ query.maxResultCount }}
      </td>
      <td>
        {{ query.firstStarted?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ query.firstFinished?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ query.lastStarted?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ query.lastFinished?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
    </tr>
  </ng-template>

  <!------------------------------

  Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
